import Breadcrumb from "../component/Breadcrumb";
import TeamSection from "../section/TeamSection";

export default function Board() {
    return(<>
    <Breadcrumb title="Board of Directores"/>
    <TeamSection />
    </>)
}